import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Password from '@components/FormInputs/Password';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';
import { useRegistrationFormInstance } from '../useSelfRegistrationFormInstance';

export const PasswordFormItem = (props: RegistrationFormItemProps) => {
  const { t } = useTranslation('common');
  const [passwordValid, setPasswordValid] = useState(false);
  const form = useRegistrationFormInstance();

  return (
    <RegistrationFormItem
      label={t('Password')}
      name="password"
      required
      validateTrigger="onBlur"
      rules={[
        {
          validator(_, value) {
            if (value === undefined || value === '') {
              return Promise.reject(new Error('Please input a password!'));
            }
            if (passwordValid) {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Please enter a valid password!'));
          }
        }
      ]}
      {...props}
    >
      <Password
        onChange={(val: string) => form.setFieldValue('password', val)}
        setValid={(val) => setPasswordValid(val)}
      />
    </RegistrationFormItem>
  );
};
